import { IcdCode } from "core/types";
import { dp } from "ds_legacy/materials/metrics";
import { Subheading } from "ds_legacy/materials/typography";
import {
  BodyWrapper,
  StringField,
  StringValue,
} from "dsl/organisms/PatientProfileDetailsShared/shared";
import Translations from "translations/types";

export type IcdValue = {
  additional_icd_codes: Array<IcdCode> | null | undefined;
  icd_code: IcdCode | null | undefined;
};

function getAdditionalIcdCodesList(icd_codes: Array<IcdCode>) {
  return icd_codes.map(
    (codeItem) => `(${codeItem.code}) ${codeItem.description} `,
  );
}

export function StaticIcdCodes({
  translations,
  value,
}: {
  additional_icd_codes?: Array<IcdCode>;
  icd_code?: IcdCode;
  translations: Translations;
  value: IcdValue | null | undefined;
}) {
  const formattedValue =
    value?.additional_icd_codes &&
    getAdditionalIcdCodesList(value.additional_icd_codes).join("\n");

  return (
    <>
      <Subheading bold>
        {translations.patient.medicalDiagnosis.icdCodes}
      </Subheading>
      <StringField
        prefix={
          translations.patient.medicalDiagnosis.icdCodeMainPatientInfoLabel
        }
        testId="icd_code_description"
        value={
          value?.icd_code?.code &&
          value.icd_code.description &&
          `(${value.icd_code.code}) ${value.icd_code.description}`
        }
      />
      {formattedValue && (
        <BodyWrapper column>
          {`${translations.patient.medicalDiagnosis.icdCodesAdditionalPatientInfoLabel}${translations.general.colon} `}
          <div style={{ marginLeft: dp(-16) }}>
            <StringValue
              multiLine
              testId="additional_icd_codes"
              value={formattedValue}
            />
          </div>
        </BodyWrapper>
      )}
    </>
  );
}
